import React, { useState, useCallback } from "react";
import { observer } from "mobx-react";
import { Container, Section, SectionLabel, SidebarSection, SectionChatPanel } from "./HomePageV2.styled";
import { Sidebar, ChatPanel, DocumentEditor } from "./components";
import { useStore } from "../../../hooks";

const HomePageV2 = observer(() => {
  const { chatStore } = useStore();
  const [isSidebarCollapsed, setIsSidebarCollapsed] = useState(false);

  const handleToggleSidebarCollapse = useCallback(() => {
    setIsSidebarCollapsed((prev) => !prev);
  }, []);

  const handleSelectConversation = useCallback(
    (conversationUuid) => {
      chatStore.setSelectedConversation(conversationUuid);
    },
    [chatStore]
  );

  const handleSelectAgent = useCallback(
    (agentId) => {
      chatStore.setSelectedAgent(agentId);
    },
    [chatStore]
  );

  const handleNewChat = useCallback(() => {
    chatStore.clearSelection();
  }, [chatStore]);

  return (
    <Container>
      {/* Sidebar Izquierdo - Navegación de Agentes y Chats */}
      <SidebarSection $isCollapsed={isSidebarCollapsed}>
        <Sidebar
          isCollapsed={isSidebarCollapsed}
          onToggleCollapse={handleToggleSidebarCollapse}
          selectedConversationId={chatStore.selectedConversationId}
          onSelectConversation={handleSelectConversation}
          selectedAgentId={chatStore.selectedAgentId}
          onSelectAgent={handleSelectAgent}
          onNewChat={handleNewChat}
        />
      </SidebarSection>

      {/* Panel Central - Chat */}
      <SectionChatPanel>
        <ChatPanel
          selectedConversationId={chatStore.selectedConversationId}
          selectedAgentId={chatStore.selectedAgentId}
        />
      </SectionChatPanel>

      {/* Panel Derecho - Editor de Documentos 
      <Section>
        <SectionLabel>DocumentEditor (Editor de Documentos)</SectionLabel>
        <DocumentEditor />
      </Section>
      */}
    </Container>
  );
});

export default HomePageV2;
